import { CreateProjectRequest, ProjectInfo, SaveProjectSharesRequest, UpdateProjectRequest } from '../models/Api';
import ApiService from './ApiService';
import { BehaviorSubject } from 'rxjs';
import { Dispatch, SetStateAction } from 'react';

type EditRowDataType = {
  id: string;
  editName: string;
  editDescription: string | null | undefined;
};

export const createProjectRequest = (values: EditRowDataType) => {
  return {
    projectId: values.id,
    name: values.editName as string,
    description: values.editDescription as string | null,
    isDeleted: false,
  };
};

const initialState = null;

const state$ = new BehaviorSubject<ProjectInfo | null>(initialState);

const setState = (data: ProjectInfo | null) => {
  return state$.next(data);
};

const ProjectService = {
  create: async (createProjectRequestObject: CreateProjectRequest) => {
    const api = ApiService.getApi();
    const response = api.projectsCreate(createProjectRequestObject);
    return response;
  },

  update: async (updatedData: UpdateProjectRequest) => {
    const api = ApiService.getApi();
    const response = await api.projectsUpdate(updatedData.projectId, updatedData);
    return response.data.updated;
  },

  delete: async (updateRequest: UpdateProjectRequest) => {
    const api = ApiService.getApi();
    const response = await api.projectsUpdate(updateRequest.projectId, updateRequest);
    return response.data.deleted;
  },

  undoDelete: async (updateRequest: UpdateProjectRequest) => {
    const api = ApiService.getApi();
    const response = await api.projectsUpdate(updateRequest.projectId, updateRequest);
    return response.data.deleted;
  },

  getRecentlyCreatedProject: (setProjectToAdd: Dispatch<SetStateAction<ProjectInfo | null>>) => {
    return state$.asObservable().subscribe((next) => setProjectToAdd(next));
  },

  updateRecentlyCreatedProject: (project: ProjectInfo | null) => {
    setState(project);
  },

  getProjectShares: async (projectId: string) => {
    const api = ApiService.getApi();
    const response = await api.getProjectShares(projectId);
    if (response.status === 200) {
      return response.data;
    }
  },

  saveProjectShares: async (projectId: string, request: SaveProjectSharesRequest) => {
    const api = ApiService.getApi();
    const response = await api.saveProjectShares(projectId, request);
    if (response.status === 200) {
      return response.data;
    }
  },
};

export default ProjectService;
